import { render, staticRenderFns } from "./driver_scorecard_comparison.vue?vue&type=template&id=5af30618&scoped=true&"
import script from "./driver_scorecard_comparison.vue?vue&type=script&lang=js&"
export * from "./driver_scorecard_comparison.vue?vue&type=script&lang=js&"
import style0 from "./driver_scorecard_comparison.vue?vue&type=style&index=0&id=5af30618&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af30618",
  null
  
)

export default component.exports